import React from 'react';
import Image from 'react-bootstrap/Image';
import cx from 'classnames';
import PropTypes from 'prop-types';

const PhotoProduct = ({ photos, productsLength }) => {
    const { main } = photos;
    const imageClasses = cx('product__thumbnail', {
        'product__thumbnail-more': productsLength > 3,
    });

    const props = {
        'data-content': productsLength > 3 && `+  ${productsLength - 3}`,
    };
    return (
        <div className={imageClasses} {...props}>
            <Image src={main.thumbnail} />
        </div>
    );
};

PhotoProduct.propTypes = {
    photos: PropTypes.object.isRequired,
    productsLength: PropTypes.number.isRequired,
};

export default PhotoProduct;
